import { DefaultImageProps } from './types';
import { FAB_LOGO_WHITE_IMAGE_URL } from './urls';

export const FabLogoWhiteImage = ({ className, ...props }: DefaultImageProps) => (
  <img
    className={className}
    src={FAB_LOGO_WHITE_IMAGE_URL}
    alt="fab-logo"
    {...props}
  />
);
